import { Injectable } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faGauge,
  faList,
  faGear,
  faRightFromBracket,
  faDatabase,
  faFileExcel,
  faCircle,
  faPlus,
  faPen,
  faTrash,
  faChevronDown,
  faBars,
  faBarsStaggered,
  faXmark,
  faArrowLeft,
  faDownload,
  faUpload,
  faAxeBattle,
  faSyringe,
  faSort,
  faSortUp,
  faSortDown,
  faTrailer,
  faCow,
  faUsers,
  faPaperPlane,
  faFileInvoice,
  faStethoscope,
  faPills,
  faFilePdf,
  faMoneyBill,
  faRotate,
  faReceipt,
  faSync,
  faArrowRightFromBracket,
  faGrid2,
  faCheck,
  faCoins,
  faEnvelope,
  faFileExport,
  faCircleCheck,
  faBarn,
  faCalendar,
} from '@fortawesome/pro-regular-svg-icons';

import { faCircleCheck as faCircleCheckSolid } from '@fortawesome/pro-solid-svg-icons';
// import { faPlus, faPen, faTrash, faChevronDown, faBars, faBarsStaggered, faXmark, faArrowLeft } from '@fortawesome/pro-light-svg-icons';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor(library: FaIconLibrary) {
    // Register icons
    library.addIcons(
      // Navigation & UI
      faBars,
      faBarsStaggered,
      faXmark,
      faArrowLeft,
      faChevronDown,

      // Actions
      faPlus,
      faPen,
      faTrash,

      // Main navigation
      faGauge,
      faList,
      faGear,
      faRightFromBracket,
      faFileExcel,
      faDatabase,
      faCircle,
      faAxeBattle,
      faSort,
      faSortUp,
      faSortDown,
      faTrailer,
      faRotate,
      faCow,
      faUsers,
      faPaperPlane,
      faFileInvoice,
      faCow,
      faStethoscope,
      faPills,
      faReceipt,
      faSync,
      faArrowRightFromBracket,
      faCoins,
      faCheck,
      faCalendar
    );
  }

  getIcon(name: string) {
    const iconMap: { [key: string]: any } = {
      // Navigation & UI
      menu: faBars,
      'menu-open': faBarsStaggered,
      close: faXmark,
      'arrow-back': faArrowLeft,
      'chevron-down': faChevronDown,
      circle: faCircle,
      apps: faGrid2,
      check: faCheck,
      'circle-check': faCircleCheck,
      'circle-check-solid': faCircleCheckSolid,
      cow: faCow,
      barn: faBarn,

      // Actions
      add: faPlus,
      edit: faPen,
      delete: faTrash,
      download: faDownload,
      upload: faUpload,
      send: faPaperPlane,

      // Main navigation
      dashboard: faGauge,
      list: faList,
      settings: faGear,
      logout: faRightFromBracket,
      animals: faCow,
      relations: faUsers,
      invoices: faFileInvoice,
      invoiceAnimals: faCow,
      money: faMoneyBill,
      // Export
      file_excel: faFileExcel,
      file_pdf: faFilePdf,

      database: faDatabase,

      // Slaughter list
      axe_battle: faAxeBattle,
      syringe: faSyringe,
      sort: faSort,
      'sort-up': faSortUp,
      'sort-down': faSortDown,
      trailer: faTrailer,
      stethoscope: faStethoscope,
      pills: faPills,
      rotate: faRotate,
      receipt: faReceipt,
      sync: faSync,
      'arrow-right-from-bracket': faArrowRightFromBracket,
      coins: faCoins,
      mail: faEnvelope,
      file_export: faFileExport,
      event: faCalendar,
    };

    return iconMap[name];
  }
}
